import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { BoundFormat, toFormat } from './BoundFormat.js';
export var ABFormat = /*#__PURE__*/ function(BoundFormat) {
    "use strict";
    _inherits(ABFormat, BoundFormat);
    function ABFormat(selectA, a, b) {
        _class_call_check(this, ABFormat);
        var _this;
        _this = _call_super(this, ABFormat, [
            function(value) {
                return _assert_this_initialized(_this).selectA(value) ? _assert_this_initialized(_this).a.format(value) : _assert_this_initialized(_this).b.format(value);
            }
        ]);
        Object.defineProperties(_this, {
            selectA: {
                value: selectA
            },
            a: {
                value: toFormat(a)
            },
            b: {
                value: toFormat(b)
            }
        });
        return _this;
    }
    return ABFormat;
}(BoundFormat);
export var ABFormatWithOptions = /*#__PURE__*/ function(ABFormat) {
    "use strict";
    _inherits(ABFormatWithOptions, ABFormat);
    function ABFormatWithOptions() {
        _class_call_check(this, ABFormatWithOptions);
        return _call_super(this, ABFormatWithOptions, arguments);
    }
    var _proto = ABFormatWithOptions.prototype;
    _proto.resolvedOptions = function resolvedOptions() {
        var _this_b_resolvedOptions, _this_b, _this_a_resolvedOptions, _this_a;
        // Note:
        //  - support either formatter not actually having resolvedOptions
        //  - ensure the resolved options of a take precedence over those of b.
        return _object_spread({}, (_this_b_resolvedOptions = (_this_b = this.b).resolvedOptions) === null || _this_b_resolvedOptions === void 0 ? void 0 : _this_b_resolvedOptions.call(_this_b), (_this_a_resolvedOptions = (_this_a = this.a).resolvedOptions) === null || _this_a_resolvedOptions === void 0 ? void 0 : _this_a_resolvedOptions.call(_this_a));
    };
    return ABFormatWithOptions;
}(ABFormat);
export var ABFormatToParts = /*#__PURE__*/ function(ABFormatWithOptions) {
    "use strict";
    _inherits(ABFormatToParts, ABFormatWithOptions);
    function ABFormatToParts() {
        _class_call_check(this, ABFormatToParts);
        return _call_super(this, ABFormatToParts, arguments);
    }
    var _proto = ABFormatToParts.prototype;
    _proto.formatToParts = function formatToParts(value) {
        return this.selectA(value) ? this.a.formatToParts(value) : this.b.formatToParts(value);
    };
    return ABFormatToParts;
}(ABFormatWithOptions);

//# sourceMappingURL=ABFormat.js.map